import { Vector2Tuple } from 'three';

import { FGroupShallowNode } from '@spazious/dollhouse-shallow-graph';

import { FGroupNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class FGroupNodeImpl extends BaseNodeImpl implements FGroupNode {
  type: FNodeTypesEnum.FGroup = FNodeTypesEnum.FGroup;
  shallow: FGroupShallowNode | null = null;
  name: string = '';
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  visible: boolean = true;
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      name: this.name,
      position: this.position,
      rotation: this.rotation,
      visible: this.visible,
      shallow: this.shallow,
    };
  }
}
